<template>
  <div class="input-container zip-container">
    <input
      id="zip_code"
      v-model="$v.zipCode.$model"
      class="input input--zip"
      :class="{'input--error' : $v.zipCode.$invalid === true}"
      type="number"
      pattern="\d*"
      name="zip_code"
    >
    <span
      v-show="$v.zipCode.$invalid === true"
      class="has__error"
    >
      Invalid Zip Code
    </span>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    zip: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      zipCode: '',
      isValid: true
    }
  },
  watch: {
    // '$v.zipCode.$invalid' (value) {
    //   this.$emit('valid', (value === false), this.$options._componentTag)
    // },
    // '$v.zipCode.$pending' (value) {
    //   this.$emit('valid', (value === false), this.$options._componentTag)
    // }
  },
  created () {
    if (this.zip) {
      this.zipCode = this.zip
    } else {
      axios.get('//geoip.improvetool.com/json/')
        .then((response) => {
          this.zipCode = ((this.zipCode === '') ? response.data.zip_code : this.zipCode)
        })
        .catch((error) => {
          console.log(error)
        })
    }
    this.$emit('valid', false, this.$options._componentTag)
  },
  validations: {
    zipCode: {
      required,
      isValidPayout (val) {
        if (val === '') return true
        if (val.length !== 5) return false
        return axios.post('https://' + process.env.VUE_APP_LINK + '/api/check/zip', { zipCode: val })
          .then((response) => {
            if (response.data !== false) {
              this.$emit('input', val, response.data.city, response.data.state, 0)
              this.$emit('valid', true, this.$options._componentTag)
              return true
            } else {
              this.$emit('valid', false, this.$options._componentTag)
              this.$emit('input', val, 0, 0, 0)
              return false
            }
          })
          .catch((error) => {
            console.log(error)
            this.$emit('valid', false, this.$options._componentTag)
            return false
          })
      }
    }
  },
  methods: {
    triggerTouch () {
      this.$v.$touch()
    }
  }
}
</script>
<style lang="scss" scoped>
  .input-container {
    &.zip-container{
      width: 200px;
      margin: 0 auto;
    }
    .input {
      &.input--zip {
        width: 200px;
        font-size: 30px;
        text-align: center;
      }
    }
  }
</style>
